import { createContext, type ReactNode } from 'react';
// Null in the shipping app. The isolated web preview supplies its own renderer.
export const ExistingPreviewContext = createContext<((name: string, children: ReactNode) => ReactNode) | null>(null);

export type PreviewEnvironment = { scenario: import('./scenarios').PreviewScenario; platform: 'web' | 'ios' | 'android' };
// Authoring samples can expose native templates; shipping capabilities stay unchanged.
export const PreviewEnvironmentContext = createContext<PreviewEnvironment | null>(null);
